import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import styles from '../../Steppers/AlertStepper.module.scss';
import { ALERT_DETAILS } from '../../../../containers/Alerts/constants.alerts';

type Props = {
    formData: {
        config: {
            seatBeltMinutes: Number,
            realert: Boolean,
            realertMinutes: Number,
        },
    },
    handleTextboxChange: Function,
    handleCheckboxChange: Function,
};

class SeatbeltAlert extends React.Component<Props> {
    state = {};

    render() {
        return (
            <div className={styles['.step-content']}>
                <div className={styles['vertical-divider']}>
                    <div className={styles['step-rightside']}>
                        <form noValidate autoComplete="off">
                            <div>
                                <div>
                                    {ALERT_DETAILS.LABEL.SEATBELT_EVENT}
                                </div>
                                <div>
                                    <TextField
                                        required
                                        margin="normal"
                                        className={styles['text-wid']}
                                        id="seatBeltMinutes"
                                        name="seatBeltMinutes"
                                        type="number"
                                        InputProps={{
                                            inputProps: {
                                                min: ALERT_DETAILS.VALUE.SBLT_MIN,
                                                max: ALERT_DETAILS.VALUE.SBLT_MAX,
                                            },
                                        }}
                                        value={this.props.formData.config.seatBeltMinutes}
                                        onChange={this.props.handleTextboxChange('seatBeltMinutes')}
                                    />
                                    <span className={styles['unit-Name']}>{ALERT_DETAILS.LABEL.SEATBELT_MINUTES}*</span>
                                </div>
                            </div>
                            <div>
                                {ALERT_DETAILS.LABEL.SEATBELT_ALERT_SPEED_THRESHOLD}
                            </div>
                            <div className={styles['div-pad']}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color="primary"
                                            id="realert"
                                            name="realert"
                                            checked={
                                                this.props.formData.config.realert === true
                                            }
                                            onChange={(e) => {
                                                this.props.handleCheckboxChange('realert')(e);
                                                if (!e.target.checked) {
                                                    this.props
                                                        .handleTextboxChange('realertMinutes')({
                                                            target: {
                                                                value:
                                                                ALERT_DETAILS.VALUE.SBLT_R_DEF,
                                                            },
                                                        });
                                                }
                                            }}
                                        />
                                    }
                                    label={ALERT_DETAILS.LABEL.SEATBELT_EVENT_REALERT}
                                />
                            </div>
                            <div>
                                <TextField
                                    required
                                    margin="normal"
                                    className={styles['text-wid']}
                                    id="realertMinutes"
                                    name="realertMinutes"
                                    type="number"
                                    InputProps={{
                                        inputProps: {
                                            min: ALERT_DETAILS.VALUE.SBLT_R_MIN,
                                            max: ALERT_DETAILS.VALUE.SBLT_R_MAX,
                                        },
                                    }}
                                    disabled={!this.props.formData.config.realert}
                                    value={this.props.formData.config.realertMinutes}
                                    onChange={this.props.handleTextboxChange('realertMinutes')}
                                />
                                <span className={styles['unit-Name']}>{ALERT_DETAILS.LABEL.SEATBELT_MINUTES}</span>
                            </div>
                            <div>
                                {ALERT_DETAILS.LABEL.SEATBELT_REALERT_FREQUENCY}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default SeatbeltAlert;
